export {default as parse} from './src/dataflow';
export {default as context} from './src/context';
export {default as expression} from './src/expression';



// WEBPACK FOOTER //
// ./~/vega-runtime/index.js